import { debounce } from 'lodash'
import { useEffect, useState } from 'react'
import { FilterableColumn } from 'app/filter.utils'

export default function NumberFilter({
  column,
  value,
  onValueChange,
}: {
  column: FilterableColumn
  value?: string | string[]
  onValueChange: (val: string | string[]) => void
}) {
  const [filterValue, setFilterValue] = useState<string | string[]>()
  useEffect(() => {
    if (typeof value === `string`) {
      setFilterValue(value)
    } else {
      setFilterValue(value?.[0])
    }
  }, [])
  return (
    <input
      type="number"
      readOnly={column.readOnly}
      className="h-8 w-full rounded-lg border border-default bg-surface px-2 text-body-sm"
      defaultValue={filterValue}
      onChange={debounce((e) => onValueChange(e.target.value), 300)}
      disabled={column.readOnly}
    />
  )
}
